import { Button } from '@talentmesh/ui/components/button';
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
} from '@talentmesh/ui/components/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { useMemo } from 'react';
import { SearchPeriod } from '../../../../api/useSearchFilters';

export interface FilterMenuButtonOption<T = number | SearchPeriod> {
    value: T;
    label: string;
}

interface FilterMenuButtonProps<T = number | SearchPeriod> {
    options: FilterMenuButtonOption<T>[];
    selectedValue: T;
    onSelect: (value: T) => void;
    disabled?: boolean;
}

export const FilterMenuButton = <T = number | SearchPeriod,>({
    options,
    selectedValue,
    onSelect,
    disabled,
}: FilterMenuButtonProps<T>) => {
    const selectedLabel = useMemo(
        () => options.find((opt) => opt.value === selectedValue)?.label,
        [options, selectedValue],
    );

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="sm" disabled={disabled} className="h-7 gap-1 text-xs font-normal">
                    {selectedLabel}
                    <ChevronDown className="h-3 w-3" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
                {options.map((option) => (
                    <DropdownMenuItem
                        key={String(option.value)}
                        onClick={() => onSelect(option.value)}
                        className={option.value === selectedValue ? 'bg-accent' : ''}
                    >
                        {option.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
